import { SurchargeInfo } from "@/models/pricing/price";

/** FUMBSD-761: the API's surcharge, refreshed hourly and on product line selection */
export type SurchargeState = SurchargeInfo & {
  /** Epoch ms of the last successful fetch; 0 = never */
  fetchedAt: number;
};

/** A refresh without `force` is skipped while the last fetch is under an hour old */
export const SURCHARGE_MAX_AGE_MS = 60 * 60 * 1000;

/** The rate a price response was calculated with (its `breakdown.surcharge`) */
export type SurchargeRate = Pick<SurchargeInfo, "rate" | "label">;

export type SurchargeContext = {
  state: SurchargeState;
  dispatch: (action: SurchargeActions, force?: boolean) => Promise<void>;
  commit: (
    mutation: SurchargeMutations,
    payload: SurchargeInfo | SurchargeRate
  ) => void;
};

export enum SurchargeMutations {
  SetSurcharge = "setSurcharge",
  SeedSurcharge = "seedSurcharge"
}

export enum SurchargeActions {
  Refresh = "refresh",
  Seed = "seed"
}

export enum SurchargeGetters {
  GetSurcharge = "getSurcharge",
  GetSurchargeIsActive = "getSurchargeIsActive"
}
